<template>
  <div id="post-site-image-multi">
    <div class="card">
      <div class="card-header">
        <h3 class="card-title title">Картинка</h3>
      </div>
      <div class="card-body">
        <Uploader :server="urlToUpload" :media="media.saved" @add="addMedia" @remove="removeMedia" :maxFilesize="5" :add-form-data="{
          post_id: getPostId(),
        }"/>
      </div>
    </div>
  </div>
</template>

<script>
import "./css/style.css"
import {defineComponent, ref, watch, toRaw} from "vue"
import Uploader from "@/plugins/uploader"
import Helper from "@/services/Helper"
import Image from "@/services/Image"
import Api from "./services/Api"

export default defineComponent({
  name: "SiteImageMulti",
  components: {
    Uploader,
  },
  props: {
    postId: {
      type: Number,
    },
    images: {
      type: Object,
    },
  },
  setup(props) {
    let urlToUpload = Helper.getApiUrlPost() + '/api/v1/hpanel/post/site/image-multi'

    let postId = ref(props.postId)
    let images = ref(props.images)

    watch(() => props.postId, (val) => {
      postId.value = val
    })

    let result = []
    if (images?.value?.length > 0) {
      Object.values(images.value).forEach(val => {
        let imageUrl = Image.handle(
            val["host"],
            val["name"],
            160,
            160
        )

        result.push({
          name: val["id"],
          url: imageUrl,
        })
      })
    }

    const media = ref({
      saved: result,
      added: [],
      removed: []
    })

    function addMedia(addedImage, addedMedia) {
      media.value.added = addedMedia
    }

    function removeMedia(removedImage, removedMedia) {
      let data = toRaw(removedImage)
      let fileId = data?.name

      if (!fileId) {
        throw new Error("Неверный file_id")
      }

      Api.deleteImage(getPayload({
        post_id: postId.value,
        image_id: fileId,
      })).then(() => {
        media.value.removed = removedMedia
      })
    }

    function getPostId() {
      return postId.value
    }

    function getPayload(obj) {
      const formData = new FormData()

      Object.entries(obj).forEach(([key, val]) => {
        formData.append(key, val)
      })

      return formData
    }

    return {
      addMedia,
      removeMedia,
      media,
      urlToUpload,
      getPostId,
    }
  }
})
</script>
